import FullWidthLayout from '@shared/layouts/FullWidthLayout.vue';
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: FullWidthLayout,
      title: 'Login'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/Logout.vue')
  },
  {
    path: '/:catchAll(.*)',
    name: 'error',
    component: () => import('@shared/components/Error/NotFoundError.vue'),
    meta: {
      title: 'Error'
    }
  },
  {
    path: '/playwright-test-login',
    name: 'playwrightTestLogin',
    component: () => import('@/views/TestLogin.vue'),
    meta: {
      layout: FullWidthLayout,
      title: 'Playwright Test Login'
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      form: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      // Redirect to login page if in production
      if (import.meta.env.VITE_ENV_NAME === 'PROD') {
        next({ name: 'login' });
      } else {
        next();
      }
    }
  }
];

export default routes;
